export const getDomainFromUrl = (urlString: string) => {
  const url = new URL(urlString);
  const parts = url.hostname.split('.');
  return parts.slice(-2).join('.');
};

export const deleteCookie = (name: string) => {
  const isHttps = window.location.protocol === 'https:';
  document.cookie = `${name}=;domain=.${getDomainFromUrl(
    window.location.href,
  )};path=/;max-age=0; SameSite=Strict${isHttps ? '; Secure' : ''}`;
};

const debounce = (func : any, delay: number = 300) => {
  let timeoutId: any;

  return (...args: any) => new Promise((resolve, reject) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(async () => {
      try {
        const result = await func(...args);
        resolve(result);
      } catch (error) {
        reject(error);
      }
    }, delay);
  });
};
export default debounce;

const getEnvironmentUrl = (): any => {
  const currentEnv = window?.location?.href;
  if (currentEnv?.includes('biaiagentp.datalake-sandbox.boomi.com')) return process.env.REACT_APP_DEV_REGISTRY_PROXY_TO_SBX || '';
  if (currentEnv?.includes('qa.boomi.com')) return process.env.REACT_APP_DEV_REGISTRY_PROXY_TO_QA || '';
  if (currentEnv?.includes('prodclone.boomi.com')) return process.env.REACT_APP_DEV_REGISTRY_PROXY_TO_PROD_CLONE || '';
  if (currentEnv?.includes('pc4.preprod.boomi.com')) return process.env.REACT_APP_DEV_REGISTRY_PROXY_TO_PREPROD || '';
  if (currentEnv?.includes('platform.boomi.com')) return process.env.REACT_APP_DEV_REGISTRY_PROXY_TO_PLATFORM || '';
  if (currentEnv?.includes('euqapl.eu-pipeline.boomi.com')) return process.env.REACT_APP_DEV_REGISTRY_PROXY_TO_EU_QA_PLATFORM || '';
  if (currentEnv?.includes('platform.gb.boomi.com')) return process.env.REACT_APP_DEV_REGISTRY_PROXY_TO_EU_PROD_PLATFORM || '';
  return process.env.REACT_APP_DEV_REGISTRY_PROXY_TO_SBX || '';
};
const linkUrl = getEnvironmentUrl();
export const getSubNavMenu = (): any[] => [
  {
    id: 'AGENT_GARDEN',
    title: 'Agent Garden',
    link: '/',
    submenus: [],
    variant: 'ANCHOR_MENU_ITEM',
  },
  {
    id: 'AGENT_CONTROL_TOWER',
    title: 'Agent Control Tower',
    link: linkUrl,
    submenus: [],
    variant: 'ANCHOR_MENU_ITEM',
  },
];
export const getToolsListViewSideDrawerTopPosition = (
  isMobileView: boolean,
  newMastheadEnabled: boolean,
) => {
  if (newMastheadEnabled) {
    return isMobileView ? 100 : 56;
  }
  return 112;
};

export const hasAlphanumeric = (str: string) => {
  if (typeof str !== 'string' || str.length === 0) {
    return false;
  }

  return /[a-zA-Z0-9]/.test(str);
};

export const formatDate = (dateString: string) => {
  if (!dateString) return '—';
  const date = new Date(dateString);
  const day = date.getDate();
  const getDaySuffix = (days: number) => {
    if (days % 10 === 1 && days !== 11) return 'st';
    if (days % 10 === 2 && days !== 12) return 'nd';
    if (days % 10 === 3 && days !== 13) return 'rd';
    return 'th';
  };
  const daySuffix = getDaySuffix(day);
  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  };
  return `${day}${daySuffix} ${new Intl.DateTimeFormat(
    'en-US',
    options,
  ).format(date)}`;
};

const KNOWLEDGE_HUB_URLS = {
  sandbox: 'https://platform.sandbox.kh.boomi.com/KnowledgeHub',
};

export const getKnowledgeHubUrl = (): string => {
  const origin = globalThis.window?.location?.origin;
  if (origin?.includes('sandbox') || origin?.includes('datalake-sandbox')) return KNOWLEDGE_HUB_URLS.sandbox;
  return `${origin}/KnowledgeHub`;
};
